import {ApolloClient, InMemoryCache, HttpLink} from '@apollo/client';
import {setContext} from "@apollo/client/link/context";


const httpLink = new HttpLink({
    uri: '/graphql',
    credentials: 'include'
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = window.sessionStorage.getItem('token');
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : ""
        }
    };
});

export const client =  new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
});
